import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ContractRulesEditor } from '@/components/ContractRulesEditor';

export default function EditContractRulesDialog({
  open, onOpenChange,
  pendingRules, setPendingRules,
  handleSaveContractRules, savingRules,
  project,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-sm font-bold uppercase tracking-wider">Edit Contract Rules — {project?.contract_type}</DialogTitle>
          <DialogDescription>
            Amend contract periods, consequences, and clauses for this project.
          </DialogDescription>
        </DialogHeader>
        <ContractRulesEditor
          contractType={project?.contract_type}
          initialRules={pendingRules}
          onChange={(updated) => setPendingRules(updated)}
        />
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Cancel</Button>
          <Button onClick={handleSaveContractRules} disabled={savingRules} className="rounded-sm" data-testid="save-contract-rules-btn">
            {savingRules ? 'Saving...' : 'Save Changes'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
